export function trackGoogleEvent(action) {
  window.gtag('event', action);
}
